DOMReady( function(){
  /* ========================================================================
  * bloc auteur
  * ======================================================================== */
  if( document.querySelector('.contentauthorinfo') && document.querySelectorAll('.contentauthorinfo').length > 0 )
  {
    [... document.querySelectorAll('.contentauthorinfo .readmore')].map( elt => {
      elt.addEventListener('click', function(e){
        e.preventDefault();
        this.parentElement.innerHTML = this.dataset.description;
      });

    });
  }
});
